// Klikbare categorie-tegels bovenaan /shop — zelfde 8 tegels als de homepage-
// slider "Alles voor onder je outfit" (zie POPULAR_CATEGORIES in
// app/page.tsx). De afbeeldingen hieronder zijn alleen de fallback: zodra
// iemand via /admin/categorieen een eigen omslagfoto instelt, gebruiken we
// die (zie lib/shop-tiles.ts#bannerUitCategorie en app/shop/page.tsx) — anders bleef een nieuwe foto daar
// "vanzelf overal" onzichtbaar op deze pagina, ook al klopte het elders wel.
//
// MOW-PERF-OKT26: verhuisd uit app/shop/ShopPageClient.tsx, zodat de server (app/shop/page.tsx) de
// omslagfoto's kan opzoeken. De client deed dat eerst zelf met een Firestore-query bij het laden van
// de pagina, en haalde daarvoor de hele Firestore-SDK binnen.
export const SHOP_TILES = [
  { label: "Dames nachtkleding", slug: "dames-nachtkleding", image: "/images/categories/dames-nachtkleding.jpg" },
  { label: "Dames ondergoed", slug: "dames-ondergoed", image: "/images/categories/dames-ondergoed.png" },
  { label: "Heren nachtkleding", slug: "heren-nachtkleding", image: "/images/categories/heren-nachtkleding.jpg" },
  { label: "Heren ondergoed", slug: "heren-ondergoed", image: "/images/categories/heren-ondergoed.png" },
  { label: "Jongens nachtkleding", slug: "jongens-nachtkleding", image: "/images/doelgroep/jongens.jpg" },
  { label: "Jongens ondergoed", slug: "jongens-ondergoed", image: "/images/categories/jongens-ondergoed.png" },
  { label: "Meisjes nachtkleding", slug: "meisjes-nachtkleding", image: "/images/doelgroep/meisjes.jpg" },
  { label: "Meisjes ondergoed", slug: "meisjes-ondergoed", image: "/images/categories/meisjes-ondergoed.jpg" },
];

/** Omslagfoto van een categorie-document; dezelfde voorkeursvolgorde als voorheen in de client. */
export function bannerUitCategorie(data: { bannerImage?: string; bannerImageDesktop?: string; bannerImageMobile?: string } | undefined): string | undefined {
  return data?.bannerImage || data?.bannerImageDesktop || data?.bannerImageMobile || undefined;
}
